<template>
  <v-app>
    <v-app-bar
      app color="#ffffff" 
    >
      <div v-if="isAuthenticated">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-app-bar-nav-icon large color="#009ee9" v-bind="attrs" v-on="on"></v-app-bar-nav-icon>
          </template>
          <v-list>
            <v-list-item to="tournament"><v-list-item-title>Create/Edit Tournament</v-list-item-title></v-list-item>
            <v-list-item to="pool"><v-list-item-title>Start/Edit Pool</v-list-item-title></v-list-item>
            <v-list-item to="pool-entry"><v-list-item-title>Your Pool Entries</v-list-item-title></v-list-item>
            <v-list-item to="invite"><v-list-item-title>Invite Friends to Join</v-list-item-title></v-list-item>
            <v-list-item to="result-entry"><v-list-item-title>Enter Tournament Results</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-img
          alt="KewlPewl Logo"
          class="shrink mr-2"
          contain
          src="/kp-25.png"
          transition="scale-transition"
          width="190"
          to="/"
        />
      </div>

      <v-spacer></v-spacer>

      <div v-if="isAuthenticated">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon >
              <v-icon large color="primary" v-bind="attrs" v-on="on">mdi-account-circle</v-icon>
            </v-btn>
            <!--<v-avatar color="primary" v-if="isAuthenticated">
              <span class="white--text headline">{{ userInitials }}</span>
            </v-avatar>-->
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title class="primary--text">{{userProfile.userFName}} {{userProfile.userLName}}</v-list-item-title>
            </v-list-item>
            <v-list-item to="profile"><v-list-item-title>Profile</v-list-item-title></v-list-item>
            <v-list-item to="password"><v-list-item-title>Change Password</v-list-item-title></v-list-item>
            <v-list-item @click="userLogout"><v-list-item-title>Logout</v-list-item-title></v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-app-bar>

    <v-main>
      <keep-alive>
      <router-view/>
      </keep-alive>
    </v-main>
    <v-footer>
      <v-col offset-md="3" :md="6">
        <div class="text-center my-n3">
          Powered By Rust, Actix-Web, MySQL, Node, Vue &amp; Vuetify
        </div>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'userProfile',
      'userInitials',
      'authStatus',
      'isAuthenticated'
    ])
  },
  data: () => ({
    //
  }),
  created: function()  {
    this.$store.dispatch('authenticateToken')
  },
  methods: {
    userLogout() {
      this.$store.dispatch('userLogout')
      this.$router.push('/')
    }
  }
};
</script>
